import { jsx as _jsx } from "react/jsx-runtime";
import logo from './ms-logo.svg';
import { mergeStyles } from '@fluentui/react';
/**
 * The Microsoft icon (just the flag without any text)
 */
export const MicrosoftLogoIcon = () => (_jsx("img", { alt: '', className: mergeStyles({
        alignSelf: 'center',
        padding: '0 8px 0 12px',
        '@media (max-width: 640px)': {
            padding: '0 6px 0 6px',
        },
    }), height: '16', src: logo, width: '16' }));
